import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PushPinIcon from '~/components/Icons/PushPinIcon';

export const UnpinWarning: FC = () => {
  const { t } = useTranslation();

  return (
    <p className="flex items-start gap-2 rounded-xl bg-black/5 px-3 py-3 text-sm text-black/70">
      <PushPinIcon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <span>{t('community.action_menu.move_post_unpin_warning')}</span>
    </p>
  );
};
